interface Identifiable {
  id: string | null;
}

export function orderByIds<T extends Identifiable>(
  records: readonly T[],
  orderedIds: readonly string[]
): T[] {
  const positions = new Map<string, number>();

  orderedIds.forEach((id, index) => {
    if (!positions.has(id)) positions.set(id, index);
  });

  const positionOf = (record: T) =>
    record.id === null ? undefined : positions.get(record.id);

  return [...records].sort((a, b) => {
    const positionA = positionOf(a);
    const positionB = positionOf(b);

    if (positionA !== undefined && positionB !== undefined) {
      return positionA - positionB;
    }

    if (positionA !== undefined) return -1;
    if (positionB !== undefined) return 1;

    return compareIds(a.id, b.id);
  });
}

function compareIds(a: string | null, b: string | null) {
  if (a === b) return 0;
  if (a === null) return 1;
  if (b === null) return -1;

  return a.localeCompare(b, undefined, { numeric: true });
}
